
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms'
import { PartnerService } from '../../services/partner.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-partner-orders',
  templateUrl: './partner-orders.component.html',
  styleUrls: ['./partner-orders.component.scss']
})

export class PartnerOrdersComponent implements OnInit {
  statusMessage: string = "Loading data please wait...";
  orderItemList: Observable<any>;
  isPageEditable: boolean = true;
  constructor(private _partnerService: PartnerService, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.getOrder();
  }

  getOrder() {
    this._partnerService.getPartnerOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order
          }
          console.log(this.orderItemList)

        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";

        }

      );
  }

  showList(item) {
    if (item.IsDisplayItem) {
      item.IsDisplayItem = false;
    }
    else {
      item.IsDisplayItem = true;
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/partnerUI/partner-orders/partner-orders.component.ts